import React, { useEffect, useState } from 'react';
import axiosInstance from '../utils/axiosInstance';
import '../styles/Pages.css';

function Leads() {
  const [leads, setLeads] = useState([]);
  const [filteredLeads, setFilteredLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [statusFilter, setStatusFilter] = useState('All');
  const [sourceFilter, setSourceFilter] = useState('All');
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    const fetchLeads = async () => {
      try {
        const response = await axiosInstance.get('/leads');
        setLeads(response.data);
        setFilteredLeads(response.data);
        setLoading(false);
      } catch (err) {
        setError('Failed to load leads.');
        setLoading(false);
      }
    };

    fetchLeads();
  }, []);

  const handleFilterChange = (e) => {
    const selectedStatus = e.target.value;
    setStatusFilter(selectedStatus);
    filterLeads(selectedStatus, sourceFilter, searchQuery);
  };

  const handleSourceFilterChange = (e) => {
    const selectedSource = e.target.value;
    setSourceFilter(selectedSource);
    filterLeads(statusFilter, selectedSource, searchQuery);
  };

  const handleSearchChange = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    filterLeads(statusFilter, sourceFilter, query);
  };

  const filterLeads = (status, source, query) => {
    let updatedLeads = leads;

    if (status !== 'All') {
      updatedLeads = updatedLeads.filter((lead) => lead.status === status);
    }

    if (source !== 'All') {
      updatedLeads = updatedLeads.filter((lead) =>
        source === 'Chat'
          ? lead.notes?.toLowerCase().includes('chat')
          : !lead.notes?.toLowerCase().includes('chat')
      );
    }

    if (query) {
      updatedLeads = updatedLeads.filter(
        (lead) =>
          lead.name.toLowerCase().includes(query) ||
          lead.email.toLowerCase().includes(query)
      );
    }

    setFilteredLeads(updatedLeads);
  };

  if (loading) return <p>Loading leads...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div className="page-container">
      <h1>Leads</h1>

      {/* Filters Section */}
      <div className="search-filter-container">
        <div className="filter-container">
          <label htmlFor="statusFilter">Filter by Status: </label>
          <select
            id="statusFilter"
            value={statusFilter}
            onChange={handleFilterChange}
          >
            <option value="All">All</option>
            <option value="New">New</option>
            <option value="In Progress">In Progress</option>
            <option value="Closed">Closed</option>
          </select>
        </div>

        <div className="filter-container">
          <label htmlFor="sourceFilter">Filter by Source: </label>
          <select
            id="sourceFilter"
            value={sourceFilter}
            onChange={handleSourceFilterChange}
          >
            <option value="All">All</option>
            <option value="Chat">Chat Assistant</option>
            <option value="Manual">Manual</option>
          </select>
        </div>

        <div className="search-container">
          <label htmlFor="searchQuery">Search: </label>
          <input
            id="searchQuery"
            type="text"
            value={searchQuery}
            onChange={handleSearchChange}
            placeholder="Search by name or email"
          />
        </div>
      </div>

      {filteredLeads.length === 0 ? (
        <p>No leads available.</p>
      ) : (
        <table className="leads-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Loan Amount</th>
              <th>Status</th>
              <th>Source</th>
            </tr>
          </thead>
          <tbody>
            {filteredLeads.map((lead) => (
              <tr key={lead._id}>
                <td>{lead.name}</td>
                <td>
                  <a href={`mailto:${lead.email}`}>{lead.email}</a>
                </td>
                <td>
                  <a href={`tel:${lead.phoneNumber}`}>{lead.phoneNumber}</a>
                </td>
                <td>${lead.loanAmount.toLocaleString()}</td>
                <td>{lead.status}</td>
                <td>{lead.source || lead.notes || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default Leads;